export const commonMixin = {
    methods: {
        imageError(e) {
            if (!e.target) return;
            e.target.remove()
        },
    }
}